import styled from 'styled-components';

const InputWrapper = styled.div`
  width: 230px;
  /* 屏幕宽度大于 1552 像素的样式 */
  @media only screen and (min-width: 1552px) {
    width: 254px;
    margin-right: ${(props) => props.lgmr}px;
  }
`;

export default InputWrapper;
